<template>
  <div class="page noselect text-center pageAsOverlay">
    <AppHead v-if="$store.getters.showDialogContainer" @menu="doBack"></AppHead>

    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->
    <div class="prelative">
      <h2 class="mt-8">Meine Zahlungsmittel</h2>
      <!--      <div>DEBUG authFailed {{!!authFailed}}</div>-->
      <!--      <div>DEBUG showCardForm={{ showCardForm }}</div>-->
      <!--      <div>DEBUG showAdd={{ showAdd }}</div>-->

      <!--    <v-btn class="btn-df okBtn mr-3 mt-4" @click.native.passive="testIframe">Test iframe-->
      <!--    </v-btn>-->
      <v-container grid-list-md>
        <div class="mb-4">
          <!--          <img class="invertImg" src="../assets/icons/powered_by_stripe.png">-->
        </div>

        <div class="indented" v-if="showCardForm === false">
          <div v-if="paymentMethods.length === 0" class="pb-7">
            <h3>Du hast aktuell keine Zahlungsmittel</h3>
          </div>

          <div class="paymentMethodsBox" v-for="pMethod in paymentMethods" :key="pMethod.aliasId">
            <table class="paymentRowsTable" v-if="pMethod.label">
              <!--ng-click on row -->
              <tr>
                <!--<td class="a"><img ng-src="../v/images/myDrinkWhite.png"></td>-->
                <td class="a">
                  <v-icon large class="myAccent">mdi-credit-card</v-icon>
                </td>
                <td class="b">
                  <!--                  {{ pMethod.countryCode }}-->
                  <div>{{ pMethod.label }}</div>
                  <div>{{ pMethod.xxxNumber }}</div>
                  <div>{{ pMethod.exp }}</div>
                </td>
                <td class="text-right" style="" v-if="paymentMethods.length>1">
                  <v-btn v-if="$store.getters.showDialogContainer" class="btn-mini" @click.ative.passive="chooseCard(pMethod)"
                  >Auswählen
                  </v-btn>
                </td>
                <td class="text-center" style="width: 60px">
                  <!--                        <img style="width: 32px;  height: auto;  margin: 0 4px;  margin-top: 5px;"-->
                  <!--                             src="../assets/icons/item-minus.png" alt="Delete">-->
                  <v-icon medium class="myBlack pointer" @click.native.passive="showDeleteDialog(pMethod)">
                    mdi-delete-forever
                  </v-icon>
                  <!--    <v-icon medium>remove_circle_outline</v-icon>-->
                  <!--    <img style="width: 30px; height: auto;   margin-right: 10px;" ng-src="../v/images/minus.png">-->
                </td>
              </tr>
            </table>
          </div>

          <div v-if="$store.getters.showDialogContainer">
            <v-btn class="btn-df okBtn mt-5 mb-5" v-if="paymentMethods.length === 1" @click.native.passive="cc">
              Mit der Bestellung fortfahren
            </v-btn>
          </div>

          <div>
            <v-btn
              rounded
              class="mt-4 mb-7 rounded100"
              :class="{'btn-mini': $store.getters.showDialogContainer && paymentMethods.length>0, 'btn-df':!($store.getters.showDialogContainer && paymentMethods.length>0)}"
              @click.native.passive="doAdd">
              Karte hinzufügen
            </v-btn>
          </div>

          <div>
            <v-btn class="bback" v-if="$store.getters.showDialogContainer"
                   @click.native.passive="closeDialog">
              Zurück
            </v-btn>
          </div>
        </div>

        <div class="indented prelative" v-show="showCardForm">
          <h4 class="mb-3">16-stellige (4x4) Nummer eingeben:</h4>
          <!-- placeholder for Elements -->
          <div class="superCenter pt-3">
            <div class="wallet-width mb-4" style="height: 100px">
              <!--            <div class="" style="height: 130px; width: 280px">-->
              <!--              <div class="gpField">-->
              <!--                <input class="gpField" id="fields-holder-name" readonly>-->
              <!--              </div>-->

              <!--              MASTERCARD Testcards-->
              <!--              5204 2452 5052 2095-->
              <!--              Expiration Date: 12/2024-->
              <!--              CVC: 111-->

              <!--              HINWEIS: Von den Apple Pay Testkarten werden zurzeit lediglich die Mastercard PANs unterstützt werden, nicht aber Visa.-->
              <!--              Apple Testcards https://developer.apple.com/apple-pay/sandbox-testing/-->
              <!--              VISA Testcard => does not work, use MASTERCARD instead-->
              <!--              4761 3497 5001 0326-->
              <!--              Expiration Date: 12/2025-->
              <!--              CVV: 747-->


              <!--       Goodpay Testcard: 9010003150000001-->
              <!--              https://docs.saferpay.com/home/integration-guide/testing-and-go-live#visa-and-v-pay-->
              <!--       Testcards: https://test.saferpay.com/vt2/Api/Post/270028/17759980/inri9t9e0tw537wlils8o65l8 -->
              <form>
                <div class="gpField mb-3">
                  <input class="gpField" id="fields-card-number" readonly>
                </div>
                <div class="d-flex gpField">
                  <input class="gpField flex60 pr-1" id="fields-expiration" readonly>
                  <input class="gpField flex40 pl-1" id="fields-cvc" readonly>
                </div>
              </form>
            </div>

            <!--            <div class="pt-2">-->
            <!--              Errors: {{ JSON.stringify(ccErrors) }}-->
            <!--            </div>-->

            <div class="pb-2">
              <div class="d-inline-block text-center">
                <div id="card-button" v-if="!authFailed">
                  <v-btn id="card-button" class="btn-df mt-4" @click.native.passive="clickAdd">Hinzufügen
                  </v-btn>
                </div>
                <div v-if="authFailed">
                  <v-btn
                    class="btn-df mt-4" @click.native.passive="reloadAll">Formular zurücksetzen
                  </v-btn>
                </div>
                <v-btn class="bback" style="margin-right: 0" @click.native.passive="cancle">
                  Abbrechen
                </v-btn>
              </div>
            </div>
          </div>

        </div>

        <div class="spacer-25"></div>

        <div>
          <div><h4>🚩 Hast du noch kein Google Pay oder Apple Pay?</h4></div>
          <p>Goolge Pay und Apple Pay kannst du in vielen Supermmärkten,
            Drogeriemärkten, Online-Shops und vielen weiteren Geschäften in ganz Europa nutzen. Schau dir an,
            wie
            man es einrichtet:</p>
          <div class="d-inline-block pay">
            <table>
              <tr>
                <td><img class="pointer" @click.passive="clickGPay" src="../assets/payment/googlepay.png">
                </td>
                <td>
                  <div style="width: 25px"></div>
                </td>
                <td><img class="pointer" @click.passive="clickAPay" src="../assets/payment/applepay.png">
                </td>
              </tr>
            </table>
          </div>
        </div>


        <div class="spacer-40"></div>

        <!--            <div class="text-center">-->
        <!--                <v-btn-->
        <!--                        rounded-->
        <!--                        class="btn-df"-->
        <!--                        onclick="window.history.back()"-->
        <!--                >-->
        <!--                    Zurück-->
        <!--                </v-btn>-->
        <!--            </div>-->

        <div class="absAdd">
          <v-btn
            class="rounded100"
            v-show="showAdd"
            color="accent"
            fab
            @click.native.passive="doAdd"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>

        <!--Delete Dialog-->
        <!--            <v-dialog activator="#foo" v-model="deleteDialog" persistent max-width="400" :light="true">-->
        <!--                <v-card>-->
        <!--                    <v-card-title class="headline">-->
        <!--                        Willst du "{{selectedPaymentMethod.label}}" wirklich löschen?-->
        <!--                    </v-card-title>-->
        <!--                    <v-card-actions class="d-block">-->
        <!--                        <v-btn flat-->
        <!--                               @click.native.passive="doRemovePaymentMethod">-->
        <!--                            Ja-->
        <!--                        </v-btn>-->
        <!--                        <v-btn flat @click.native.passive="deleteDialog = false">Nein</v-btn>-->
        <!--                    </v-card-actions>-->
        <!--                </v-card>-->
        <!--            </v-dialog>-->
        <!--End Delete Dialog-->
      </v-container>

      <BoxLoading
        v-if="loading"
      ></BoxLoading>
    </div>

    <!--        <FixBasket></FixBasket>-->

  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as util from '@/vendor/util'
import * as xhr from '../api/xhr.js'
import * as qconst from '../vendor/qconstants'
import * as bootstrap from "../vendor/bootstrap";
import AppHead from "@/components/AppHead.vue";
import BoxLoading from "@/components/BoxLoading.vue";
import {getGlobalValue, getGlobalValueOrZero, removeGlobalKey, setGlobalKeyValue} from "@/util/globalState";
import {action$DeleteGpPaymentMethod, action$GoodpayFrontendApi} from "../vendor/qconstants";
import * as goodpayUtil from "@/goodpay/goodpayUtil";
import {googlePaymentMethods} from "@/goodpay/googlePay/googlePayUtil";
import {getErrorDetails} from "@/util/globalErrorHandler";
import {doReload} from "../vendor/util";

export default {
  name: "PaymentMethods",
  components: {AppHead, BoxLoading},
  // components: {FixBasket},
  data() {
    return {
      loading: false,
      alreadyInitCounter: 0,
      duringInit: false,
      unloadTargetTime: 0,
      deleteDialog: false,
      authFailed: false,

      //Goodpay
      fieldsAlreadyInit: false,
      showGpSubmit: false,
      goodpayScriptCreated: false,
      goodpayWalletTransaction: null,
      goodpayCreditTransaction: null,
      goodpayAliasToken: '',
      goodpayExpireAt: 0,
      gpFieldsToken: '',
      cardElementExists: false,
      showAdd: true,
      showCardForm: false,
      ccErrors: '',

      // stripeCardElement: null,

      // asGuest: !!this.$ls.get('asGuest', true),

      selectedPaymentMethod: {aliasId: '', label: ''},

      fromCheckout: false,

      showAddButton: false,
      iv1: null,
    }
  },
  // watch: {
  //     //https://github.com/vuejs/vue-router/issues/1735
  //     $route(to, from) {
  //         if (to.name && from.name === null) {
  //             if (store.getters.loggedIn === false) {
  //                 this.$router.push({name: 'Home'});
  //             }
  //         }
  //     }
  // },
  computed: {
    paymentMethods() {
      return store.getters.paymentMethods;
    }
  },
  created() {
    ebus.$on('paymentMethodWasAdded', () => {
      this.showCardForm = false;
    });
    ebus.$on('goodpayAliasRedirect', (params) => {
      let now = Date.now();
      let easer = getGlobalValueOrZero('loadEaserGoodpayAliasRedirect');
      if (!easer || now - parseInt(easer) > 5 * 1000) {
        setGlobalKeyValue('loadEaserGoodpayAliasRedirect', now);
      } else {
        //eased
        return;
      }
      this.goodpayAliasRedirect();
    });
    ebus.$on('addCardForCheckout', () => {
      this.loading = true;
      setGlobalKeyValue('pmForCheckout', true);
      this.showCardForm = true;
      setTimeout(() => {
        this.doAdd();
      }, 100);
    });
    ebus.$on('cb-deleteCard', (yesOrNo) => {
      //follow invitation of friend or not
      if (yesOrNo === 'yes') {
        this.doRemovePaymentMethod();
      }
    });
  },
  // mounted() {
  //     this.init();
  // },
  // beforeMount() {
  //     if (store.getters.loggedIn === false) {
  //         this.$router.push({name: 'Home'});
  //     }
  // },
  mounted() {
    ebus.$emit('pullBuyersProfile');
    let cont = getGlobalValue('fromCheckout') || false;
    this.fromCheckout = cont;
    // if (this.paymentMethods.length === 0) {
    // this.init();
    // }
    if (cont) {
      // setTimeout(() => {
      //neue karte hinzufügen anzeigen
      this.doAdd();
      // }, 800);//mount takes a view millis
    }

    this.iv1 = setInterval(() => {
      //TODO test on Android and iPhone
      // if (bootstrap.isIos()) {
      //     this.showAddButton = !this.isInputFocused();
      // } else {
      this.showAddButton = true;
      // }

    }, 500);

    // store.commit('currentRoute', 'paymentMethods');
    // setTimeout(() => {
    //     jumpToTop();
    // }, 80);
  },
  destroyed() {
    this.duringInit = false;
    util.clearEvents([
      'paymentMethodWasAdded',
      'goodpayAliasRedirect',
      'addCardForCheckout',
      'cb-deleteCard',
    ]);
    util.clearTheInterval(this.iv1);
  },
  methods: {
    closeDialog() {
      store.commit('showDialogContainer', false);
    },
    chooseCard(pm) {
      ebus.$emit('gpPaymentMethodSelected', pm);
    },
    testIframe() {
      store.commit('secondSelectedDialog', 'IframeOverlay');
      store.commit('showDialogContainer', true);
      setGlobalKeyValue('ccRedirectUrl', 'https://test.de/');
      ebus.$emit('triggerIframeOverlay', 'https://test.de/');
    },
    doBack() {
      removeGlobalKey('fromCheckout');
      ebus.$emit('goBack')
    },
    initFields() {
      // if (!navigator.onLine) {
      //     return;
      // }

      if (this.duringInit) {
        return;
      }
      if (this.fieldsAlreadyInit) {
        console.log('goodpay fields are already init');
        this.alreadyInitCounter += 1;
        if (this.alreadyInitCounter > 1) {
          doReload('fieldsAlreadyInit');
        }
        this.stopLoading();
        return;
      }
      this.duringInit = true;

      try {

        setGlobalKeyValue('ccRequestId', util.generateClientId());

        let self = this;

        SaferpayFields.init({
          // access token
          accessToken: goodpayUtil.accessToken,
          // api url
          url: (goodpayUtil.walletEnvironment === 'TEST' ? ('https://test.saferpay.com/Fields/' + goodpayUtil.customerId) : ('https://www.saferpay.com/Fields/' + goodpayUtil.customerId)),
          style: {
            '.form-control': 'border: none; border: solid 1px #ccc; border-radius: 15px; height: 40px',
            '.cardnumber': 'height: 40px;',
            '.expiration': 'height: 40px; padding-right: 15px',
            '.cvc': 'height: 40px;',
          },
          paymentMethods: googlePaymentMethods,
          onSuccess: function () {
            // Callback function, that is executed, every time, the Saferpay Fields have been loaded successfully.
            console.log('goodpay onSuccess fields.init');
            self.fieldsAlreadyInit = true;
            self.showGpSubmit = true;
            self.showCreditForm = false;
            self.stopLoading(self);
            // alert('fields init ok');
          },
          onError: function (evt) {
            //eventCallback : Callback function, that is executed, every time, the initialization of the Saferpay
            // Fields has not been successful. The event returns an Error Callback Message.
            console.log('goodpay onError fields.init ' + JSON.stringify(evt));
            self.showGpSubmit = false;
            // alert('fields init error');
          },
          placeholders: {
            //Custom Text for Input placeholders
            holdername: 'NONE',
            // holdername: 'Name des Karteninhabers',
            cardnumber: '0000 0000 0000 0000',
            expiration: 'MM/YY',
            // expiration: 'MM/JJJJ',
            cvc: 'CVC'
          },
          onBlur: function (evt) {
            //Callback on blur (Card Holder leaves field)
            console.log('goodpay onBlur');
          },
          onValidated: function (e) {
            //Callback similar to on blur (Card Holder leaves field), but explicitly delivers validation data
            self.ccErrors = 'The value in field ' +
              e.fieldType + ' is ' + (e.isValid ? 'valid.' : 'invalid.');
            console.log('goodpay onValidated e ' + JSON.stringify(e));

            // logToConsole(
            //   "The value in field " +
            //   e.fieldType +
            //   " is " +
            //   (e.isValid ? "valid." : "invalid.")
            // );
          },
          onFocus: function (evt) {
            //Callback on focus (Card Holder clicks into field)
            console.log('goodpay onFocus');
          }
        });

        this.duringInit = false;

      } catch (eCreate) {
        this.duringInit = false;
        console.log('goodpay error in create card-element: ' + eCreate);
      }
    },

    cc() {
      ebus.$emit('gpPaymentMethodSelected', this.paymentMethods[0]);
      // if (store.getters.showDialogContainer) {
      //   store.commit('showDialogContainer', false);
      // } else {
      // ebus.$emit('goBack');
      // }
    },

    clickGPay() {
      ebus.$emit('openGooglePay');
    },

    clickAPay() {
      ebus.$emit('openApplePay');
    },

    showDeleteDialog(paymentMethod) {
      this.selectedPaymentMethod = paymentMethod;
      ebus.$emit('showQuestion', {
        quest: 'Willst du ' + this.selectedPaymentMethod.label + ' wirklich löschen?',
        // yesLabel: '',
        // noLabel: '',
        // yesAction: null,
        cb: 'cb-deleteCard'
      });
    },

    safeUnload(seconds, self) {
      try {
        if (!self) {
          self = this;
        }
        if (isNaN(seconds)) {
          seconds = 6;
        }
        let now = Date.now();
        let millis = seconds * 1000;
        let targetTime = now + millis;
        self.unloadTargetTime = targetTime
        this.loading = true;
        setTimeout(() => {
          let diff = Date.now() - self.unloadTargetTime;
          if (diff > -600 && diff < 600) {
            this.loading = false;
          }
        }, millis);
      } catch (e) {
        console.log('error in safeUnload: ' + e.message);
      }
    },

    goodpayAliasRedirect() {
      this.safeUnload(3);
      store.commit('secondSelectedDialog', '');
      if (store.getters.secondSelectedDialog) {
      } else {
        store.commit('showDialogContainer', false);
      }
      removeGlobalKey('ccRedirectUrl');
      this.aliasAssertInsert(this);
    },

    doAdd() {
      try {
        this.$nextTick(() => {
          this.safeUnload(2);
          this.showCardForm = true;
          this.showAdd = false;
          setTimeout(() => {
            this.initFields();
          }, 300);
        });
      } catch (e) {
        console.log('goodpay error in doAdd: ' + e.message);
      }
    },

    reloadAll() {
      doReload('reloadAll in PaymentMethods');
    },

    clickAdd() {
      this.safeUnload(10.0);
      setTimeout(() => {
        this.submitCc();
      }, 200);
    },

    stopLoading(self) {
      if (!self) {
        self = this;
      }
      self.loading = false;
      self.unloadTargetTime = 0;
    },

    submitCc() {
      this.safeUnload();
      let self = this;
      SaferpayFields.submit({
        // https://docs.saferpay.com/home/integration-guide/licences-and-interfaces/saferpay-fields#saferpay-fields-initialization
        onSuccess: function (e) {
          //Callback on successful Submit
          // Once the onSuccess event is called, you need to forward the Saferpay Fields token to your server-backend,
          // in order to initialize the next step (see above) and also gather the RedirectUrl, to perform things like
          // 3D Secure and/or DCC. How you move the token to the backend is completely up to you. You can provide the
          // onSuccess event with an AJAX-method, to execute the initialization in the background on a successful submit
          // and forward the RedirectUrl to the fronend for a redirect this way, which you then can open in an iframe,
          // Lightbox, or as a full redirect. However a redirect via GET, or POST, towards your initialize-script,
          // is also an option. Refer to the above mentioned chapters, to learn, how to initialize a transaction, or
          // just save a card, using a Saferpay Fields token.
          console.log("goodpay submitCc onSuccess Payment token = '" + e.token + "'");
          self.gpFieldsToken = e.token;
          self.aliasInsert(self, e.token);
        },
        onError: function (evt) {
          self.stopLoading(self);
          //Callback on unsuccessful Submit
          // console.log('goodpay submitCc onError ' + JSON.stringify(evt));
          if (evt.message.indexOf('has already been used')) {//because token has already been used
            // alert('already exists detected');
            self.showCardForm = false;
            setTimeout(() => {
              self.doAdd();
            }, 400);
            return;
          }
          ebus.$emit('showInfo', {
            title: 'Fehler bei der Verarbeitung: ' + evt.message,
          });
        }
      });
    },

    aliasAssertInsert(self) {
      try {
        self.safeUnload();
        let cardToken = self.goodpayAliasToken;
        console.log('goodpay aliasInsert for token ' + cardToken);
        if (!cardToken) {
          return;
        }
        // if (!this.paymentRequestCreated) {
        try {
          let msg = {
            action: action$GoodpayFrontendApi,
            method: 'aliasAssertInsert',
            data: {
              requestId: getGlobalValue('ccRequestId'),
              cardToken: cardToken,
            },
          };
          xhr.xhrSend(true, msg, (reply) => {
            if (reply.ok && reply.response && reply.response.ok) {
              console.log('goodpay aliasAssertInsert was ok: ' + JSON.stringify(reply));
              let obj = reply.response.obj;
              //reply:
              // {
              //   "ok": true,
              //   "response": {
              //   "ok": true,
              //   "obj": {
              //     "ResponseHeader": {
              //       "SpecVersion": "1.35",
              //         "RequestId": "aliasAssertInsert_1699119566161_30o"
              //     },
              //     "Alias": {
              //       "Id": "226b93f70f9c4105ae53ec21cc9fd537",
              //         "Lifetime": 1096
              //     },
              //     "PaymentMeans": {
              //       "Brand": {
              //         "PaymentMethod": "VISA",
              //           "Name": "VISA"
              //       },
              //       "DisplayText": "xxxx xxxx xxxx 0001",
              //       "Card": {
              //         "MaskedNumber": "xxxxxxxxxxxx0001",
              //           "ExpYear": 2022,
              //           "ExpMonth": 2,
              //           "HolderSegment": "CONSUMER",
              //           "CountryCode": "CH"
              //       }
              //     },
              //     "CheckResult": {
              //       "Result": "OK_AUTHENTICATED",
              //       "Message": "Strong online check was successful.",
              //       "Authentication": {
              //            "Result": "OK",
              //            "Message": "Strong customer authentication was successful.",
              //            "Xid": "d53a7190-f417-4fea-9117-c1d4d85f0677"
              //       },
              //       "IssuerReference": {
              //         "TransactionStamp": "795691530540692055476"
              //       }
              //     }
              //   }
              // }
              // }

              //check if checkResult was ok
              try {
                if (obj.CheckResult && obj.CheckResult.Authentication.Result !== 'OK') {
                  //TODO display error message tu user
                  ebus.$emit('showInfo', {
                    title: 'Error! Die Authentifikation ist fehlgeschlagen.',
                    text: ''
                  });
                } else {
                  let paymentMethod = {
                    aliasId: obj.Alias.Id,
                    label: obj.PaymentMeans.Brand.Name,
                    xxxNumber: obj.PaymentMeans.DisplayText,
                    exp: obj.PaymentMeans.Card.ExpMonth + '/' + obj.PaymentMeans.Card.ExpYear,
                    countryCode: obj.PaymentMeans.Card.CountryCode,
                  }
                  self.savePaymentMethod(paymentMethod, self);
                }
              } catch (e) {
                console.log('goodpay error: ' + e.message);
                ebus.$emit('showInfo', {
                  title: 'Error! Die Karte wurden nicht erkannt.',
                  text: ''
                });
                self.stopLoading(self);
                ebus.$emit('throwError', getErrorDetails(e, 'PaymentMethods aliasAssertInsert',
                  'Die Karte wurden nicht erkannt. error=' + e.message));
              }
            } else {
              console.log('error: goodpay aliasInsert was notOk');
              self.authFailed = true;
              let PayerMessage = 'Die Verarbeitung ist fehlgeschlagen.';
              try {
                let pm = reply.response.PayerMessage;
                PayerMessage = pm || PayerMessage;
              } catch (e) {

              }

              let allDetails = [];
              // let allDetails = [errorDetail. ErrorName, ErrorMessage, ProcessorName, ProcessorMessage];
              let ErrorDetail = '';
              try {
                ErrorDetail = reply.response.ErrorDetail;
                allDetails.push(ErrorDetail);
              } catch (e) {

              }
              let ErrorName = '';
              try {
                ErrorName = reply.response.ErrorName;
                allDetails.push(ErrorName);
              } catch (e) {

              }
              let ErrorMessage = '';
              try {
                ErrorMessage = reply.response.ErrorMessage;
                allDetails.push(ErrorMessage);
              } catch (e) {

              }
              let ProcessorName = '';
              try {
                ProcessorName = reply.response.ProcessorName;
                allDetails.push(ProcessorName);
              } catch (e) {

              }
              let ProcessorMessage = '';
              try {
                ProcessorMessage = reply.response.ProcessorMessage;
                allDetails.push(ProcessorMessage);
              } catch (e) {

              }
              ebus.$emit('showInfo', {
                title: 'Fehler! ' + PayerMessage,
                text: allDetails.join(', ')
              });
              self.stopLoading(self);
              ebus.$emit('throwError', getErrorDetails('aliasInsert was notOk', 'PaymentMethods aliasAssertInsert',
                PayerMessage + ' ' + allDetails.join(', ')));
            }
          }, (err) => {
            console.log('goodpay aliasInsert unexpectederror: ' + err);
            ebus.$emit('showInfo', {
              title: 'Error!  Ein unerwarteter Fehler ist aufgetreten.',
              text: ''
            });
            self.stopLoading(self);
          });
        } catch (e) {
          console.log('goodpay error aliasInsert: ' + e.message);
        }

      } catch (ex) {
        this.notifyError('Internet Verbindungsfehler goodpay');
        let e = 'goodpay PaymentRequest error takeaway mp: ' + ex.message;
        console.log(e);
        ebus.$emit('throwError', getErrorDetails(e));
        // ebus.$emit('forceReload');
      }
    },

    async savePaymentMethod(pm, self) {
      self.safeUnload(10, self);
      let btaste = bootstrap.getBtaste();
      let updates = pm;
      updates.deviceId = btaste;

      let aliasId = pm.aliasId;

      let msg = {
        action: qconst.action$DocUpserter,
        updates: updates,
        collectionName: 'gpPaymentMethods',
        // prefix: 'shop_',
        subjectKey: {
          key: 'aliasId',
          value: aliasId,
        },
        autoRetry: true,
      };
      await xhr.xhrSend(true, msg, (reply) => {
        if (reply && reply.ok) {
          console.log('push: gpPaymentMethods saved successfully for aliasId ' + aliasId);
          // self.safeUnload(6, self);
          let methods = store.getters.paymentMethods;
          methods.push(updates);
          store.commit('paymentMethods', methods);
          setGlobalKeyValue('gpAddedPaymentMethod', updates);

          setTimeout(() => {
            ebus.$emit('paymentMethodWasAdded', aliasId);

            if (getGlobalValue('pmForCheckout')) {
              removeGlobalKey('pmForCheckout');
              store.commit('showDialogContainer', false);
              store.commit('selectedDialog', '');
              this.cc();
            }
          }, 1500);

          setTimeout(() => {
            ebus.$emit('pullBuyersProfile', true);
            self.$nextTick(() => {
              self.showCreditForm = false;
              ebus.$emit('toast', 'Die Karte wurde erfolgreich hinzugefügt');
              self.stopLoading(self);
            });
          }, 2200);
        } else {
          self.stopLoading(self);
        }
      });
    },

    aliasInsert(self, cardToken) {
      try {
        self.safeUnload();
        console.log('goodpay aliasInsert for token ' + cardToken);
        // if (!this.paymentRequestCreated) {
        try {
          let msg = {
            action: action$GoodpayFrontendApi,
            method: 'aliasInsert',
            data: {
              requestId: getGlobalValue('ccRequestId'),
              cardToken: cardToken,
            },
          };
          let self = this;
          xhr.xhrSend(true, msg, (reply) => {
            if (reply.ok && reply.response && reply.response.ok) {
              console.log('goodpay aliasInsert was ok: ' + JSON.stringify(reply));
              self.goodpayCreditTransaction = reply.response.obj;
              //reply:
              // {
              //   "ok": true,
              //   "response": {
              //   "ok": true,
              //     "obj": {
              //     "ResponseHeader": {
              //       "SpecVersion": "1.35",
              //         "RequestId": "aliasInsert_1699046096763_rms"
              //     },
              //     "Token": "zsnd7q3nnzzk2npa2km38nht5",
              //       "Expiration": "2023-11-03T23:15:20.696+01:00",
              //       "RedirectRequired": true,
              //       "Redirect": {
              //       "RedirectUrl": "https://test.saferpay.com/vt2/Api/SharedThreeDS/270028/17759980/p1bicn189phqug47vah64e8ax",
              //         "PaymentMeansRequired": false
              //     }
              //   }
              // }
              // }

              self.goodpayAliasToken = reply.response.obj.Token;
              self.goodpayExpireAt = (new Date(reply.response.obj.Expiration)).getTime();
              if (reply.response.obj.RedirectRequired || reply.response.obj.Redirect) {
                let redirectUrl = reply.response.obj.Redirect.RedirectUrl;
                console.log('goodpay aliasInsert'
                  + ' goodpayAliasToken: ' + self.goodpayAliasToken
                  + ' redirectUrl: ' + redirectUrl);

                setGlobalKeyValue('ccRedirectUrl', redirectUrl);
                store.commit('secondSelectedDialog', 'IframeOverlay');
                store.commit('showDialogContainer', true);
                ebus.$emit('triggerIframeOverlay', redirectUrl);
                self.stopLoading(self);
              } else {
                console.log('goodpay aliasInsert'
                  + ' goodpayAliasToken: ' + self.goodpayAliasToken);
                self.aliasAssertInsert(self);
              }
            } else {
              console.log('error: goodpay aliasInsert was notOk');
              self.stopLoading(self);
            }
          }, (err) => {
            console.log('goodpay aliasInsert unexpectederror: ' + err);
            self.stopLoading(self);
          });
        } catch (e) {
          console.log('goodpay error aliasInsert: ' + e.message);
        }

      } catch (ex) {
        this.notifyError('Internet Verbindungsfehler goodpay');
        let e = 'goodpay PaymentRequest error takeaway mp: ' + ex.message;
        console.log(e);
        ebus.$emit('throwError', getErrorDetails(e));
        // ebus.$emit('forceReload');
      }
    },

    notifyError(text, err) {
      ebus.$emit('showInfo', {
        title: text,
        text: err || ''
      });
      // this.$notify({
      //     type: 'error',
      //     title: text,
      //     text: err || ''
      // });
    },

    isInputFocused() {
      try {
        let tn = window.document.activeElement.tagName.toLowerCase();
        // alert('tn = ' + tn);
        return tn === 'iframe';
      } catch (e) {

      }
    },

    cancle() {
      if (this.isInputFocused()) {
        //do nothing if the stripe input form is still the focus
        return;
      }
      this.showCardForm = false;
      this.showAdd = true;
    },

    //note: AttachPaymentMethodToCustomer silently update the buyer automatically
    // updatePaymentMethodsInDb() {
    //     let msg = {
    //         action: qconst.action$UpdatePaymentMethodsOfStripeBuyer,
    //         fuid: firebaseUtil.getUser().uid,
    //         stripeCustomerId: store.state.stripeCustomerId
    //     };
    //     xhr.xhrSend(false, msg);
    // },

    doRemovePaymentMethod() {
      this.safeUnload(3);
      let aliasId = this.selectedPaymentMethod.aliasId;
      let detachMsg = {
        action: action$DeleteGpPaymentMethod,
        aliasId: aliasId,
      };

      xhr.xhrSend(true, detachMsg, (reply) => {
        this.deleteDialog = false;
        if (reply.ok) {
          let methods = store.getters.paymentMethods;
          let filtered = methods.filter(pm => pm.aliasId !== aliasId);
          store.commit('paymentMethods', filtered);
          ebus.$emit('toast', 'Die Karte wurde erfolgreich entfernt');
          setTimeout(() => {
            ebus.$emit('pullBuyersProfile', true);
          }, 1200);
          this.stopLoading();
        } else {
          this.notifyError('Unerwarteter Fehler', 'Bitte versuche es erneut');
        }
      }, (err) => {
        this.notifyError('Unerwarteter Fehler', err);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/base';
/*@import '../styles/sharedStyles';*/

.pageAsOverlay * {
  @include text-contrast($appBgColor);
}

.gpField {
  height: 40px;
  width: 100%;
  margin: 2px 0;
}

.pay {
  img {
    height: 60px;
    width: auto;
  }
}


.absAdd {
  position: fixed;
  bottom: 15px;
  right: 15px;
  width: 60px;
  height: 60px;
}

.paymentMethodsBox {
  margin: 15px 5px;
}

.cardForm {
  padding-bottom: 16px;
}

.vdevice-not-xs {
  .cardForm {
    margin-left: 11vw;
    margin-right: 11vw;
  }
}

.betterButton {
  margin: 15px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  background-color: $color-primary;
  @include material-shadow(1);
  color: white;
}

// .cardBox {
//        margin: 4px;
//        padding: 16px 8px 0 8px;
//        color: rgba(white, 0.90);
//        border-radius: 7px;
//        @include material-shadow(1)
//    }


</style>
